// SPDX-License-Identifier: GPL-3.0-or-later
// Copyright (C) 2026 Breach Contributors

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AppState {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  auditMode: boolean;
  setAuditMode: (v: boolean) => void;
  pro: boolean;
  setPro: (v: boolean) => void;
}

export const useStore = create<AppState>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
      auditMode: false,
      setAuditMode: (v) => set({ auditMode: v }),
      pro: false,
      setPro: (v) => set({ pro: v }),
    }),
    { name: 'breach-store' }
  )
);
